/** @format */

import {useRouteSensorPage} from 'helpers/hooks/useRouteSensorPage';

import {MainText, MainTextBox, Root, ValueBox} from './styles';

interface Props {
  name: string;
  text: string;
  value: string;
}

const SensorDetailed = ({name, text, value}: Props) => {
  const {onSensorClick} = useRouteSensorPage();

  const handleClick = () => {
    onSensorClick(name);
  };

  return (
    <Root>
      <MainTextBox>
        <MainText onClick={handleClick}>{text}</MainText>
      </MainTextBox>
      <ValueBox>{value}</ValueBox>
    </Root>
  );
};

export {SensorDetailed};
